import EnumSet from 'Services/enumSet'

interface IPeriodDates extends EnumSet {
  monthly: number
  quarterly: number
  biannual: number
  yearly: number
}

const periodDates = new EnumSet({
  monthly: { value: 1, description: 'mês' },
  quarterly: { value: 3, description: 'trimestre' },
  biannual: { value: 5, description: 'semestre' },
  yearly: { value: 12, description: 'ano' },
}) as IPeriodDates

export default periodDates